import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { AnimatedSection } from "@/components/AnimatedSection";

const FAQCommercial = () => {
  const faqs = [
    {
      question: "¿Cada cuánto debo hacer mantenimiento eléctrico?",
      answer: "Recomendamos cada 6-12 meses dependiendo del uso. Locales con muchos equipos refrigerados o maquinaria pesada necesitan mantención más frecuente (cada 6 meses). Para locales más pequeños con pocos equipos, una vez al año es suficiente."
    },
    {
      question: "¿Puedo hacer la mantención fuera de horario?",
      answer: "Sí, trabajamos fines de semana y horarios nocturnos para no interrumpir tu negocio. Entendemos que muchos locales comerciales no pueden cerrar durante el día, por lo que nos adaptamos a tus horarios de operación."
    },
    {
      question: "¿Cuánto demora la visita técnica?",
      answer: "Entre 1-3 horas según tamaño del local y cantidad de equipos. Para un minimarket o tienda pequeña usualmente toma 1-2 horas. Locales más grandes o con instalaciones complejas pueden requerir hasta 3 horas. Te avisamos con anticipación el tiempo estimado."
    },
    {
      question: "¿Qué pasa si encuentran problemas graves?",
      answer: "Te entregamos un informe detallado con todas las observaciones clasificadas por prioridad (crítico, alto, medio, bajo). Tú decides qué reparar y cuándo hacerlo. Nosotros te orientamos sobre qué es urgente y qué puede esperar, pero la decisión siempre es tuya."
    },
    {
      question: "¿Entregan boleta o factura?",
      answer: "Sí, somos empresa formal con factura electrónica. Emitimos tanto boletas como facturas según tu necesidad, con todos los documentos tributarios correspondientes para que puedas usar como gasto de tu negocio."
    },
    {
      question: "¿Qué pasa si necesito una emergencia eléctrica?",
      answer: "Contamos con servicio de emergencias 24/7. Si tienes un problema urgente (corte de luz, olor a quemado, chispas), llámanos directamente al teléfono indicado y te atenderemos lo antes posible, incluso en horarios nocturnos o fines de semana."
    },
    {
      question: "¿Incluye el certificado SEC?",
      answer: "El Plan Normalización incluye la documentación técnica necesaria para certificación SEC. Si tu local requiere certificación SEC obligatoria (según normativa), te indicamos en el informe técnico y gestionamos todo el proceso con la Superintendencia de Electricidad y Combustibles."
    },
    {
      question: "¿Cubren toda la Región Metropolitana?",
      answer: "Sí, atendemos toda la Región Metropolitana sin costo adicional por traslado en comunas urbanas. Para comunas más alejadas o zonas rurales, puede aplicar un cargo menor por movilización que te informamos previamente."
    }
  ];

  return (
    <section className="relative py-24 md:py-32 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-industrial-gray via-dark-section/90 to-industrial-gray">
        <div className="absolute bottom-20 left-10 w-96 h-96 bg-primary/20 rounded-full blur-3xl animate-liquid-blob opacity-20" />
      </div>

      <div className="relative z-10 container mx-auto px-4">
        <AnimatedSection animation="fade-in">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-montserrat font-bold text-white text-center mb-4">
            Preguntas Frecuentes
          </h2>
          <p className="text-lg text-white/70 text-center mb-12">
            Resolvemos tus dudas más comunes
          </p>
        </AnimatedSection>

        <AnimatedSection animation="slide-up" delay={100}>
          <div className="max-w-4xl mx-auto">
            <Accordion type="single" collapsible className="space-y-6">
              {faqs.map((faq, index) => (
                <AccordionItem
                  key={index}
                  value={`item-${index}`}
                  className="backdrop-blur-xl bg-white/10 border-2 border-white/20 rounded-2xl px-6 hover:bg-white/15 transition-all duration-300"
                >
                  <AccordionTrigger className="text-left text-white hover:text-primary transition-colors py-5">
                    <span className="font-montserrat font-semibold pr-4">
                      {faq.question}
                    </span>
                  </AccordionTrigger>
                  <AccordionContent className="text-white/80 pb-5 leading-relaxed">
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </AnimatedSection>
      </div>
    </section>
  );
};

export default FAQCommercial;
